export async function getCommentedParagraphs(): Promise<number[]> {
  return Word.run(async (context) => {
    const paragraphs = context.document.body.paragraphs;
    paragraphs.load("items");
    await context.sync();

    const indexes: number[] = [];

    for (let i = 0; i < paragraphs.items.length; i++) {
      const para = paragraphs.items[i];
      const comments = para.getComments();
      comments.load("items");
      await context.sync();

      if (comments.items.length > 0) {
        indexes.push(i);
      }
    }

    return indexes;
  });
}
